require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/home/runner/work/web.ivm-meyer/web.ivm-meyer/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/home/runner/work/web.ivm-meyer/web.ivm-meyer/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/home/runner/work/web.ivm-meyer/web.ivm-meyer/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/home/runner/work/web.ivm-meyer/web.ivm-meyer/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/home/runner/work/web.ivm-meyer/web.ivm-meyer/node_modules/babel-preset-stage-0/lib/index.js\",\"/home/runner/work/web.ivm-meyer/web.ivm-meyer/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./layout-home.js") })
        }
      }, "component---src-templates-layout-index-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-templates-layout-index-js!./.cache/layouts/layout-home.js
// module id = 739
// module chunks = 231608221292675